/**
 * This file contains many functions that make calls to our API and return the promises from those calls.
 */

import Api from '../api.ts';

const PasswordReset = '/password-reset';

const PasswordResetAPI = {
  /**
   * Makes call to api endpoint to get password reset link
   */
  async get(email) {
    const url = `${PasswordReset}?email=${encodeURIComponent(email)}`;
    return Api.get(url);
  },

  /**
   * Updates user password
   *
   * Backend is responsible for verifying token
   * @param token
   * @param password
   * @returns {Promise<*>}
   */
  async update(token, password) {
    const url = `${PasswordReset}`;
    return Api.put(url, { data: { token, password } });
  },
};

export default PasswordResetAPI;
